"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGqlCardToOldCard = exports.POSITION_MAPPER = exports.NETWORK_MAPPER = exports.CARD_TYPE_MAPPER = void 0;
var globalTypes_1 = require("../generated/globalTypes");
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var social_sources_1 = require("@wix/wix-vod-constants/dist/video-cards/social-sources");
var orientations_1 = require("@wix/wix-vod-constants/dist/video-cards/orientations");
var positions_1 = require("@wix/wix-vod-constants/dist/video-cards/positions");
var utils_1 = require("../../utils");
exports.CARD_TYPE_MAPPER = [
    [globalTypes_1.VideoCardType.CHANNEL, types_1.VIDEO_CARD_TYPES.CHANNEL],
    [globalTypes_1.VideoCardType.VIDEO, types_1.VIDEO_CARD_TYPES.VIDEO],
    [globalTypes_1.VideoCardType.CUSTOM, types_1.VIDEO_CARD_TYPES.CUSTOM],
    [globalTypes_1.VideoCardType.PRODUCT, types_1.VIDEO_CARD_TYPES.PRODUCT],
    [globalTypes_1.VideoCardType.RECENT_VIDEO, types_1.VIDEO_CARD_TYPES.RECENT_VIDEO],
    [globalTypes_1.VideoCardType.SOCIAL, types_1.VIDEO_CARD_TYPES.SOCIAL],
];
exports.NETWORK_MAPPER = [
    [globalTypes_1.VideoCardTargetExternalType.FACEBOOK, social_sources_1.SOCIAL_SOURCES.FACEBOOK],
    [globalTypes_1.VideoCardTargetExternalType.TWITTER, social_sources_1.SOCIAL_SOURCES.TWITTER],
    [globalTypes_1.VideoCardTargetExternalType.YOUTUBE, social_sources_1.SOCIAL_SOURCES.YOUTUBE],
];
exports.POSITION_MAPPER = [
    [globalTypes_1.VideoCardPosition.BOTTOM_LEFT, positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_LEFT],
    [globalTypes_1.VideoCardPosition.BOTTOM_RIGHT, positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT],
];
function mapGqlCardToOldCard(card, _a) {
    var clientId = _a.clientId;
    return {
        actionId: card.id,
        actionItemId: card.targetVideoId,
        actionListId: card.targetChannelId,
        buttonLabel: card.buttonText,
        type: utils_1.toOldType(card.type, exports.CARD_TYPE_MAPPER),
        network: card.targetExternalType
            ? utils_1.toOldType(card.targetExternalType, exports.NETWORK_MAPPER)
            : null,
        text: card.title,
        thumbnailUrl: card.thumbnailUrl,
        url: card.targetExternalUrl,
        updatedTimestamp: card.customOrder,
        clientId: clientId,
        orientation: orientations_1.VIDEO_CARDS_ORIENTATIONS.HORIZONTAL,
        position: utils_1.toOldType(card.position, exports.POSITION_MAPPER),
        appearance: {
            start: card.showAt,
            duration: card.hideAt - card.showAt,
        },
    };
}
exports.mapGqlCardToOldCard = mapGqlCardToOldCard;
//# sourceMappingURL=mappers.js.map